module.exports = __webpack_public_path__ + "img/feature1.a85a03f.png";